export default "__VITE_ASSET__znMSwYLX__"